import { render, staticRenderFns } from "./StudyPlanDetail.vue?vue&type=template&id=99b8ec68&scoped=true&"
import script from "./StudyPlanDetail.vue?vue&type=script&lang=js&"
export * from "./StudyPlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudyPlanDetail.vue?vue&type=style&index=0&id=99b8ec68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b8ec68",
  null
  
)

export default component.exports